import { useSelector, useStore, useDispatch } from 'react-redux';
import Palette from './svg/Palette.svg';
import G from './Getters';
import A from './ActionCreators.js';
import Edit from './svg/Edit.svg';

const groupIdMap = { userRootIds:null }

export default function useUserContextSubmenu(){

  const dispatch = useDispatch();
  const store = useStore();
  const state = store.getState();
  const groupMap = G.getWorkspaceThemeMap(state);
  let { workspace:{ groupId:currentGroupId } } = state;



  let menuItems =  Object.entries(groupMap).flatMap((entry, i) => {
    let [groupId,theme] = entry;

    let groupName = [null,"userRootIds"].includes(groupId) ? "Personal Workspace" : (
      G.getGroupName(state,groupId)
    )

    if( groupId === "userRootIds" ){
      groupId = null;
    }

    

    return {
      hoverable:true,
      title: (
        <div className="sg-row v-center">
          <div className="sg-row v-center h-center" style={{ width: 25, height: 25 }}>
            {groupId === currentGroupId && "✔"}
          </div>

          <div className="sg-row v-center h-center" style={{ width: 25 }}>
            <div themeColorPreview={theme.background}
              style={{
                width: 10,
                height: 10,
                background: theme.background,
                outline: '1px solid #ccc',
                opacity: theme.opacity * 2,
              }}
            />
          </div>

          <div style={{
            minWidth:250
          }}>{groupName}</div>
        </div>
      ),
      onClick: () => {
        debugger;
        dispatch(A.setCurrentWorkspace({
          userId:G.getUserId(state),
          groupId:groupIdMap[groupId] ?? groupId,
        }))
      }
    };

    // Add separator after first item only
    return i === 0 ? [entry, { action: "line" }] : [entry];
  });


  let finalArray = [

    { 
      hoverable:true,
      title:(
      <div 
        
        class="sg-row v-center">

        <img style={{

          width:20,
          margin:2.5,
        }} src={Edit}/>

        <img style={{
          width:20,
          margin:2.5,

        }} src={Palette}/>
        Edit Color Scheme
      </div>
    ) },
    { action:"line" },
    ...menuItems
  ]


  return finalArray;
}


;

/*
return Object.entries(groupMap).map(([groupId,theme]) => {

  return (

    {title:(

      <div  class="sg-row">

        <div class="sg-row v-center h-center" style={{width:25,height:25}}>


          {index === 0 && <div>✔</div>}
        </div>

        <div class="sg-row v-center h-center" style={{width:25}}>


          <div style={{width:10,height:10,
            background:theme.background,
            opacity:theme.opacity,
            outline:'1px solid #ccc'}}/>

        </div>
        <div>{groupId}</div>
      </div>

    ),

      onClick:() => {
        //e.stopPropagation();
        setIndex(0)
      },

    }

  )

})

/*[

        {action:"line"},

        {

          onClick:() => {
            //e.stopPropagation();
            setIndex(1)
          },

          title:(

          <div class="sg-row">

            <div class="sg-row v-center h-center" style={{width:25}}>

              {index === 1 && "✔"}


            </div>

            <div class="sg-row v-center h-center" style={{width:25}}>

              <div style={{width:10,height:10,background:'magenta', opacity:0.2,
              }}/>

            </div>
            <div>Albert Einstein's group</div>
          </div>


        )},


      ]*/

